import { Center as BaseCenter } from "@chakra-ui/react";

export default BaseCenter;
